import { Composition, Identity } from "@pdfking/tfunc"
import { CmykToRgb } from "./CmykToRgb"
import { CreateColorConvert } from "./CreateColorConvert"
import { RgbToHsl } from "./RgbToHsl"

/**
 * Converts a Color to an HSLColor
 * If the input is already HSL, it will be returned as is
 * If the input is RGB or CMYK, it will be converted to HSL
 */
export const ToHsl = CreateColorConvert(
  RgbToHsl,
  Composition(CmykToRgb, RgbToHsl),
  Identity
)
